import { useParams, useSearchParams } from 'next/navigation';

/**
 *
 * @returns object with tag filters
 * filterTagFromUrl: get tag key from url
 * noFilterTagUrl: get url without selected tag key
 * createFilterUrl: create url with given tag key
 */
export const useRatingFilterTag = () => {
  const params = useParams<{ slug: string; akl: string; ftag?: string[] }>();
  const searchParams = useSearchParams();

  const noFilterTagUrl = `/p/${params?.slug}/${params?.akl}/rating?${searchParams?.toString()}`;

  const filterTagFromUrl =
    (params?.ftag &&
      (Array.isArray(params.ftag) ? params.ftag[0] : params.ftag).replace('f-', '')) ||
    null;

  const createFilterUrl = (tag: string) =>
    `/p/${params?.slug}/${params?.akl}/rating/f-${tag}?${searchParams?.toString()}`;

  return {
    filterTagFromUrl,
    noFilterTagUrl,
    createFilterUrl,
  };
};
